export default "/images/top_logo.svg?d02ab241151e43dd236881604f2f9e29";